import numeral from "numeral";
import React, { useState } from "react";
import { toast } from "react-toastify";
import "../App.css";
import { State } from "../context/State";
import { initialState } from "../static/initialState";
import "./component.css";
import { saveState } from "./util";
import * as _ from "lodash";
import { Emoji } from "../ui/emoji";
import Link from "./Link";
import { EmailList } from "./EmailList";
import { Tertiary } from "./Tertiary";
import { MenuItem } from "@material-ui/core";
import { Select } from "@material-ui/core";
const satellite = "mapbox://styles/drewweth/ck69pz7hb2h0j1ilqz7ikuw3r";
const basic = "mapbox://styles/drewweth/ck69p7yt72g9p1irxan3hazsh";
const navigation = "mapbox://styles/drewweth/ck69q97ft1tfg1iqqdyfn4nxy";

const zoomLookup = [10, 13, 8];

export function Secondary() {
  const [[loading, loadingCount], setLoading] = useState([false, 0]);
  const getLocation = ({ view, setView }) => {
    if (navigator.geolocation || loadingCount > 0) {
      setLoading([true, loadingCount + 1]);
      navigator.geolocation.getCurrentPosition(pos => {
        setLoading([false, loadingCount + 1]);
        const coords = pos.coords;
        setView({
          ...view,
          latitude: coords.latitude,
          longitude: coords.longitude,
          zoom: zoomLookup[loadingCount % 3]
        });
      });
    } else {
      setLoading([false, 0]);
      alert("Geolocation is not supported by this browser.");
    }
  };

  return (
    <State.Consumer>
      {({
        view,
        setView,
        setLayers,
        state,
        setState,
        mapTheme,
        setMapTheme,
        showTutorial
      }) => (
        <div className="margin ">
          <div className="padding3 content shadow radius-top">
            {_.get(window, ["performance", "memory", "usedJSHeapSize"]) && (
              <div style={{ width: "5rem" }} className="inline margin-r">
                {numeral(window.performance.memory.usedJSHeapSize).format(
                  "0.0 b"
                )}
              </div>
            )}
            <div className="inline margin-r">
              <Link
                hoverDesc="Reset state of application"
                onClick={() => {
                  if (window.confirm("Discard progress and start over?")) {
                    setState(initialState);
                    saveState({
                      ...initialState,
                      showMobileWarning: state.showMobileWarning
                    });
                    toast("Reset completed", {
                      position: toast.POSITION.BOTTOM_RIGHT
                    });
                  }
                }}
              >
                New
              </Link>
            </div>
            <div className="inline margin-r">
              <Link
                hoverDesc="Save state to this browser (local storage)"
                onClick={() => saveState(state, true)}
              >
                Save
              </Link>
            </div>
            <div className="inline margin-r">
              <Select
                value={mapTheme}
                onChange={e => {
                  setMapTheme(e.target.value, state => saveState(state));
                }}
              >
                <MenuItem value={satellite}>Satellite</MenuItem>
                <MenuItem value={basic}>Basic</MenuItem>
                <MenuItem value={navigation}>Navigation</MenuItem>
              </Select>
            </div>
            <div className="inline margin-r">
              <Tertiary isLink={true} />
            </div>
            <div className="inline margin-r">
              <EmailList />
            </div>
            <div className="inline margin-r">
              <Emoji
                name="pin"
                onClick={() => getLocation({ view, setView })}
              ></Emoji>
            </div>
            <div style={{ width: "2rem" }} className="inline ">
              {loading ? (
                <img
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 1,
                    height: 36
                  }}
                  src="/spinner.gif"
                  alt="loading"
                />
              ) : (
                view.zoom.toFixed(1)
              )}
            </div>
          </div>
        </div>
      )}
    </State.Consumer>
  );
}
